// extracted by mini-css-extract-plugin
export var baseButton = "_ts-0";
export var controlsArrowKeys = "_ts-1";
export var controlsResetButton = "_ts-2";
export var lightGameButton = "_ts-4 _ts-0";
export var playAgainButton = "_ts-5 _ts-0";
export var startGameButton = "_ts-3 _ts-0";